// Cache configuration
export const CACHE_CONFIG = {
  // Cache durations
  ttl: {
    short: 5 * 60 * 1000, // 5 minutes
    medium: 30 * 60 * 1000, // 30 minutes
    long: 24 * 60 * 60 * 1000, // 24 hours
  },
  // Cache keys
  keys: {
    channels: 'channels',
    tokens: 'tokens',
    channelDetails: (id) => `channel:${id}`,
    tokenDetails: (address) => `token:${address}`,
  }
};

// Memory cache for components
const componentCache = new Map();

// Cache component with TTL
export function cacheComponent(key, component, ttl = CACHE_CONFIG.ttl.medium) {
  componentCache.set(key, {
    component,
    expiry: Date.now() + ttl
  });
}

// Get cached component
export function getCachedComponent(key) {
  const cached = componentCache.get(key);
  if (!cached) return null;
  if (Date.now() > cached.expiry) {
    componentCache.delete(key);
    return null;
  }
  return cached.component;
}

// Clear expired cache entries
export function clearExpiredCache() {
  const now = Date.now();
  for (const [key, value] of componentCache.entries()) {
    if (now > value.expiry) {
      componentCache.delete(key);
    }
  }
}

// Run cache cleanup periodically
setInterval(clearExpiredCache, 5 * 60 * 1000); // Every 5 minutes